import { API_URL } from "../services/api";

export const resolveImageUrl = (imagePath) => {
  if (!imagePath) return "";
  if (/^(https?:|data:|blob:)/i.test(imagePath)) return imagePath;
  if (imagePath.startsWith("/")) return `${API_URL}${imagePath}`;
  return `${API_URL}/${imagePath}`;
};
